import styled from 'styled-components';

interface ILabelsStyling {
  disabled?: boolean;
  type?: 'error' | 'warning' | 'loading';
}

export const LabelsWrapper = styled.div<ILabelsStyling>`
  max-width: fit-content;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 15px;
  column-gap: 6px;

  &[data-type='error'] {
    &[data-border='true'] {
      background: #faeeee;
      border: 1px solid #d14343;
    }
    > p {
      color: #d14343;
    }
  }

  &[data-type='warning'] {
    &[data-border='true'] {
      background: #fdf7f4;
      border: 1px solid #ff9900;
    }
    > p {
      color: #ff9900;
    }
  }

  &[data-type='loading'] {
    &[data-border='true'] {
      background: #f5f7fb;
      border: 1px solid #c1c4d6;
    }
    > p {
      color: #474d66;
    }
  }

  > span {
    display: inline-flex;
  }

  opacity: ${props => props.disabled && 0.6};
`;

export const CircularLabelProgressWrapper = styled.div`
  position: relative;
  height: 14px;
  width: 14px;
  border-radius: 100%;
  background-color: transparent;

  & .overllProgress {
    position: absolute;
    top: 0;
    color: #d6e0ff;
  }

  & .completedProgress {
    position: absolute;
    top: 0;
    color: #1371fe;

    circle:nth-child(1) {
      stroke-linecap: round;
    }
  }
`;

export const Text = styled.p`
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  margin: unset;
  white-space: nowrap;
`;
